import { COMPANY_ID_YANDEX } from '../../constants/yandex.js';
import { loadJs } from '../../utils/loadJs.js';
import { promiseOnce } from '../../utils/promiseOnce.js';

const loadYandexAdsContextOnce = promiseOnce(async () => {
    await loadJs('https://yandex.ru/ads/system/context.js');
});
const initBanner = ({ lazy, containerId, decoratedParams, onError, onLoad, onRender, onStub, ownerId, }) => {
    window.yaContextCb = window.yaContextCb || [];
    window.yaContextCb.push(() => {
        // @ts-expect-error Cannot find name Ya
        Ya.adfoxCode.create({
            lazyLoad: lazy,
            ownerId: ownerId ?? COMPANY_ID_YANDEX,
            containerId,
            params: decoratedParams,
            onError,
            onLoad,
            onRender,
            onStub,
        });
    });
};

export { initBanner, loadYandexAdsContextOnce };
//# sourceMappingURL=helpers.js.map
